var currentUrl = window.location.href;

$(document).ready(function () {
    // Define a global function to handle AJAX responses
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        complete: function (xhr, status) {
            var response = xhr.responseJSON;
            if (response) {
                var message = xhr.responseJSON.message ?? null;
                var errors = xhr.responseJSON.errors ?? null;

                if (message && (xhr.status == 200 || xhr.status == 201)) {
                    // Show success notification if response is present
                    handleValidationErrors(null, message, "gritter-light");

                    setInterval(() => {
                        if (response.next_url != null && response.next_url != "current_page") {
                            window.location.replace(response.next_url);
                        } else if (response.next_url != null && response.next_url == "current_page") {
                            location.reload()
                        } else {
                            return false;
                        }

                    }, 1000);

                } else if (message && (xhr.status == 422 || xhr.status == 500)) {
                    // Show error notification for other cases
                    handleValidationErrors(errors, message, "gritter-red");
                }
            }
        }
    });

    // Function to handle validation errors
    function handleValidationErrors(errors, message, className) {
        var errorMessage = '';
        $.each(errors, function (key, value) {
            errorMessage += value[0] + '<br>';
            // Add notification for each error message if needed
            // You can customize the notification style as per your requirements
        });

        // Display the error message
        showNotification(errorMessage, message, className);
    }

    // Function to show notification
    function showNotification(errorMessage, message, className) {
        // Replace this with your preferred notification method (e.g., Toastr, Bootstrap alerts, etc.)
        $.gritter.add({
            title: message,
            text: errorMessage,
            image: '',
            sticky: true,
            time: '',
            class_name: `my-sticky-class ${className}`,
            before_open: function () { },
            after_open: function (e) { },
            before_close: function (manual_close) { },
            after_close: function (manual_close) { }
        });
    }

    // Function to initialize tags based on data attributes
    function initializeTags() {
        $('[data-toggle="tags"]').each(function () {
            var target = $(this).data('target');

            // Initialize tag functionality
            $(target).tagit({
                availableTags: availableTags,
                showAutocompleteOnFocus: true,
                allowSpaces: true,
                beforeTagAdded: function (event, ui) {
                    if ($.inArray(ui.tagLabel.toLowerCase(), availableTags.map(function (tag) { return tag })) == -1) {
                        return true;
                    }
                    return true;
                }
            });
        });
    }

    $('input').on('focus', function() {
        $(this).select();
    });

    // Call the function to initialize tags
    initializeTags();

    $(".create-or-select").select2({
        tags: true
    });
});


function searchAndSelectProduct(elements, productIdArray, URL) {
    elements.select2({
        placeholder: 'Select Product',
        ajax: {
            url: URL,
            dataType: 'json',
            cache: true,
            delay: 1000,
            global: false,
            minimumInputLength: 2,
            data: function (params) {
                return {
                    search: params.term, // search term
                    page: params.page || 1,
                    product_id_array: productIdArray ?? null
                };
            },
            processResults: function (data, params) {
                var products = [];
                var currentPage = data.current_page || 1;
                var lastPage = data.last_page || 1;

                if (currentPage === 1 || currentPage < lastPage) {
                    Object.keys(data.data).forEach(function (key) {
                        var productId = parseInt(key);
                        var productText = data.data[key];
                        products.push({
                            id: productId,
                            text: productText
                        });
                    });
                }

                return {
                    results: products,
                    pagination: {
                        more: currentPage < lastPage
                    }
                };
            },
        }
    })
}

function searchAndSelectProductForPkg(elements, productIdArray, URL) {
    elements.select2({
        placeholder: 'Add Packages From Product',
        ajax: {
            url: URL,
            dataType: 'json',
            cache: true,
            delay: 1000,
            global: false,
            async: false,
            minimumInputLength: 2,
            data: function (params) {
                return {
                    search: params.term, // search term
                    page: params.page || 1,
                    product_id_array: productIdArray ?? null
                };
            },
            processResults: function (data, params) {
                var products = [];
                var currentPage = data.current_page || 1;
                var lastPage = data.last_page || 1;

                if (currentPage === 1 || currentPage < lastPage) {
                    Object.keys(data.data).forEach(function (key) {
                        var productId = parseInt(key);
                        var productText = data.data[key];
                        products.push({
                            id: productId,
                            text: productText
                        });
                    });
                }

                return {
                    results: products,
                    pagination: {
                        more: currentPage < lastPage
                    }
                };
            },
        }
    })
}

function fetchCarrier(carrierTypeId, elementName, url, selectedKey = null) {
    if (carrierTypeId) {
        var request = null;
        request = {carrier_types_id: carrierTypeId}
        
        //null string check fix
        if(selectedKey == "null" || selectedKey == "" || selectedKey == null){
            selectedKey = [];
        }else{
            selectedKey = selectedKey.split(",");
        }

        $.ajax({
            url: url,
            dataType: "JSON",
            method: "GET",
            async: false,
            data: request,
            success: (data, msg) => {
                if (data) {
                    var text = "<option value='' " + (selectedKey.length == 0 ? "selected" : "") + " >--Select Carries--</option>"
                    $.each(data, (key, value) => {
                        text += `<option value="${value.id}" ${selectedKey.includes(String(value.id)) ? 'selected':''}>${value.name}</option>`
                    })
                    $(`${elementName}`).html(text)
                }
            }, error: (data, msg) => {
                console.log(data, msg)
            }
        })
    }
}

function fetchCarrierService(carrierId, elementName, url, selectedKey = null, carrierTypeId = false) {
    console.log(selectedKey)
    if (carrierId) {
        var request = null;

        if(carrierTypeId == false){
            request = { carrier_id: carrierId }
        } else {
            request = {carrier_types_id: carrierId,}
        }

        //null string check fix
        if(selectedKey == "null" || selectedKey == "" || selectedKey == null){
            selectedKey = [];
        } else{
            selectedKey = selectedKey.split(",");
        }   

        $.ajax({
            url: url,
            dataType: "JSON",
            method: "GET",
            async: false,
            data: request,
            success: (data, msg) => {
                if (data) {
                    var text = "<option value='' " + (selectedKey.length == 0 ? "selected" : "") + " >--Select Service--</option>"
                    $.each(data, (key, value) => {
                        text += `<option value="${value.id}" ${selectedKey.includes(String(value.id)) ? 'selected':''}>${value.name}</option>`
                    })

                    $(`${elementName}`).html(text)
                }
            }, error: (data, msg) => {
                console.log(data, msg)
            }
        })
    }
}

function fetchCarrierDefaultService(elementName, carrierId, url, residentialIndicator = false) {
    if (carrierId) {
        $.ajax({
            url: url,
            dataType: "JSON",
            method: "GET",
            async: false,
            data: { carrier_Id: carrierId,
                residential: residentialIndicator
             },
            success: (data, msg) => {
                if (data) {
                    if(data['service'] != null)
                    {
                        var element = $(elementName);
                        var option = element.find(`option[value=${data['service']}]`);
                        option.prop('selected', true);

                        //$(`${elementName}`).val(data['service']);
                        //(`${elementName} option[value=${data['service']}]`).prop('selected', true);
                    }
                    //$(`${elementName}`).val(data['service']);
                    //$(`${elementName} option[value=${data['service']}]`).prop('selected', true);
                }
            }, error: (data, msg) => {
                console.log(data, msg)
            }
        })
    }
}

function fetchCarrierPackages(carrierId, elementName, url, selectedKey = null, carrierTypeId = false) {
    if (carrierId) {
        var request = null;

        if(carrierTypeId == false){
            request = { carrier_id: carrierId}
        }else{
            request = {carrier_types_id: carrierId,}
        }

        //null string check fix
        if(selectedKey == "null" || selectedKey == "" || selectedKey == null){
            selectedKey = [];
        }else{
            selectedKey = selectedKey.split(",");
        }

        $.ajax({
            url: url,
            dataType: "JSON",
            method: "GET",
            async: false,
            data: request,
            success: (data, msg) => {
                if (data) {
                    var text = "<option value='' " + (selectedKey.length === 0 ? "selected" : "") + " >--Select Package--</option>"
                    $.each(data, (key, value) => {
                        text += `<option value="${value.id}" ${selectedKey.includes(String(value.id)) ? 'selected':''}>${value.name}</option>`
                    })

                    $(`${elementName}`).html(text)
                }
            }, error: (data, msg) => {
                console.log(data, msg)
            }
        })
    }
}

function fetchCarrierDefaultPackage(elementName, carrierId, url, residentialIndicator = false) {
    if (carrierId) {
        $.ajax({
            url: url,
            dataType: "JSON",
            method: "GET",
            async: false,
            data: { carrier_Id: carrierId,
                    residential: residentialIndicator
             },
            success: (data, msg) => {
                if (data) {
                    if(data['package'] != null)
                    {
                        var element = $(elementName);
                        var option = element.find(`option[value=${data['package']}]`);
                        option.prop('selected', true);
                        //$(`${elementName}`).val(data['package']);
                        //$(`${elementName} option[value=${data['package']}]`).prop('selected', true);
                    }
                    //$(`${elementName}`).val(data['package']);
                    //$(`${elementName} option[value=${data['service']}]`).prop('selected', true);
                }
            }, error: (data, msg) => {
                console.log(data, msg)
            }
        })
    }
}


// ==== Attach functions to window ====
window.searchAndSelectProduct = searchAndSelectProduct;
window.searchAndSelectProductForPkg = searchAndSelectProductForPkg;
window.fetchCarrier = fetchCarrier;
window.fetchCarrierService = fetchCarrierService;
window.fetchCarrierDefaultService = fetchCarrierDefaultService;
window.fetchCarrierPackages = fetchCarrierPackages;
window.fetchCarrierDefaultPackage = fetchCarrierDefaultPackage;
